import { render, staticRenderFns } from "./GeofenceAttributeTab.vue?vue&type=template&id=2e4566be"
import script from "./GeofenceAttributeTab.vue?vue&type=script&lang=js"
export * from "./GeofenceAttributeTab.vue?vue&type=script&lang=js"
import style0 from "./GeofenceAttributeTab.vue?vue&type=style&index=0&id=2e4566be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports